export default __webpack_public_path__ + "fonts/KFOlCnqEu92Fr1MmEU9fBBc4.woff2";